import angular from 'angular';
import FileUploadsDirective from './file-upload.directive';
import template from './file-upload.html'
import "./file-upload.scss"

let FileUploadsModule = angular.module('file-upload-module', [])

    .directive('inputFile', FileUploadsDirective)

    .name;

export default FileUploadsModule;


// WEBPACK FOOTER //
// ./client/app/common/file-upload/index.js